import { useState } from 'react';
import { Alert, IconButton, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from 'src/styles/theme';

const CollapsibleAlert = ({ collapse = false, children }) => {
  const [show, setShow] = useState(!collapse);

  return (
    <Collapse in={show}>
      <Alert
        severity="info"
        sx={{
          backgroundColor: colors.dropzone.background,
          border: `1px solid ${colors.primary.light}`,
          color: colors.primary.dark,
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setShow(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {children}
      </Alert>
    </Collapse>
  );
};

export default CollapsibleAlert;
